import styled from 'styled-components';
export const Container = styled.div`
  width : 800px;
  height : 100%;
  max-height: 450px;
  min-height: 450px;
`;

export const Video = styled.video`
    width : 100%;
    height : 100%;
    max-width : unset;
    background : black;
    margin : 0;
    display : flex;
`;

export const Source = styled.source`
    width : 100%;
    height : 100%;
`;